import { render, staticRenderFns } from "./Roll.vue?vue&type=template&id=5d7e4ae8&scoped=true&"
import script from "./Roll.vue?vue&type=script&lang=js&"
export * from "./Roll.vue?vue&type=script&lang=js&"
import style0 from "./Roll.vue?vue&type=style&index=0&id=5d7e4ae8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7e4ae8",
  null
  
)

export default component.exports